'use strict';

export class Vipprofileinfo {
    constructor(component_key) {
        this.id = component_key;
        this.$root = jQuery(`.js-${this.id}`);
        this.$closeBtn = this.$root.find(`.js-${this.id}_close`);
        this.$openOverlayBtn = this.$root.find('.js-open_vip_info');
        this.csrf = this.$root.data('csrf');
    }

    init() {
        if (!this.$root.length) return;
        this.bind_events();
    }

    bind_events() {
        this.$closeBtn.on('click', () => {
            if (this.csrf) {
                yalwa.basics.ajaxservice({
                    type: 'POST',
                    resource: 'profilepage',
                    action: 'dismiss_vip_promo',
                    csrf: this.csrf
                });
            }

            this.$root.fadeOut(300, () => {
                this.$root.remove();
            });
        });

        this.$openOverlayBtn.on('click', () => {
            jQuery(`.js-dialog_infoicon`).appendTo('body');
            yalwa.v.component_instances['dialog_infoicon'].show();
            
            const slide_options = {
                css_prefix: 'infocard__',
                timeout: 7000,
                container_class: 'js-simple_auto_slide_vipinfo',
                bullets: {container_class: 'js-slider_vipinfo_pagination_container'},
                clickable: false,
            };
            this.pf_info_slider = new yalwa.basics.simple_auto_slide(slide_options);
            this.pf_info_slider.start();
        });
    }
}

// Auto-initialize based on component ID prefix [cite: 348]
Object.keys(yalwa.v.components).forEach(key => {
    if (key.startsWith('vipprofileinfo_')) {
        new Vipprofileinfo(key).init();
    }
});